import { Container } from '@/components/layout/Container'

export function Terms() {
  return (
    <div className="pt-28 pb-24">
      <Container className="max-w-3xl">
        <h1 className="mb-8 font-display text-4xl normal-case text-carbon md:text-5xl">
          Terms of Service
        </h1>
        <p className="mb-12 text-sm text-carbon/60">Last updated: October 2026</p>

        <div className="space-y-8 leading-relaxed text-carbon/70">
          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">1. Acceptance of terms</h2>
            <p>
              By accessing or using the little sky website, creating an account, or making a
              purchase, you agree to these Terms of Service. If you do not agree, please do not use
              our services.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">2. Orders and payment</h2>
            <p>
              All prices are listed in Nigerian Naira (₦) and include applicable VAT unless stated
              otherwise. Payment is processed securely through Paystack. Orders are confirmed only
              after successful payment authorisation.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">3. Shipping and delivery</h2>
            <p>
              We ship to addresses within Nigeria using our logistics partners. Delivery timeframes
              are estimates and may vary by location. You are responsible for providing an accurate
              shipping address.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">4. Returns and refills</h2>
            <p>
              Sample costs are credited toward a full-bottle purchase. Refill services are available
              for eligible sizes. Full return and refund requests may be submitted within 7 days of
              delivery for unopened items.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">5. Account and conduct</h2>
            <p>
              You agree to provide accurate account information and not misuse the site, including
              attempts to interfere with security features or make fraudulent purchases.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">6. Contact</h2>
            <p>
              For questions about these terms, email us at hello@littlesky.com.
            </p>
          </section>
        </div>
      </Container>
    </div>
  )
}
